import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInbox } from "@fortawesome/free-solid-svg-icons";

export default function EmptyState({ icon = faInbox, title = "No data yet", message = "Nothing to show here at the moment." }) {
  return (
    <div className="dashboard-empty-state text-center py-5 px-3">
      <div className="dashboard-empty-icon mx-auto mb-3">
        <FontAwesomeIcon icon={icon} />
      </div>
      <div className="dashboard-empty-title">{title}</div>
      <div className="dashboard-empty-message">{message}</div>
    </div>
  );
}
